<template>
    <div class="modalTopContentShare">
        <h3>{{ modalTopContent.title }}</h3>
        <div class="row">
            <div class="col-sm-4">
                <div class="row">
                    <div class="col-auto">
                        <img :src="require(`@/assets/images/icon/home_small.svg`)">
                        <h4>主辦單位</h4>
                    </div>
                    <div class="col-auto">
                        <p>{{ modalTopContent.CompanyName }}</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="row">
                    <div class="col-auto">
                        <img :src="require(`@/assets/images/icon/map_small.svg`)">
                        <h4>上課地點</h4>
                    </div>
                    <div class="col-auto">
                        <p>{{ modalTopContent.ClassAddress }}</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="row">
                    <div class="col-auto">
                        <img :src="require(`@/assets/images/icon/nuber_small.svg`)">
                        <h4>發票號碼</h4>
                    </div>
                    <div class="col-auto">
                        <p>{{ modalTopContent.InvoiceNo }}</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="row">
                    <div class="col-auto">
                        <img :src="require(`@/assets/images/icon/time_small.svg`)">
                        <h4>開課日期</h4>
                    </div>
                    <div class="col-auto">
                        <p>{{ modalTopContent.ClassBTime }} ~ {{ modalTopContent.ClassETime }}</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="row">
                    <div class="col-auto">
                        <img :src="require(`@/assets/images/icon/man_small.svg`)">
                        <h4>報名人數</h4>
                    </div>
                    <div class="col-auto">
                        <p>{{ modalTopContent.OrderCnt }}</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="row">
                    <div class="col-auto">
                        <img :src="require(`@/assets/images/icon/money_small.svg`)">
                        <h4 style="word-spacing:20px;">金&nbsp;額</h4>
                    </div>
                    <div class="col-auto">
                        <p>{{ modalTopContent.Amount | currency }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            modalTopContent:{
                type:Object,
                required:true,
            },
        },
    }
</script>